import { ButtonBase, styled } from '@mui/material'

import { UserAvatar } from '@collaborate-health/uikit'

export const UserAvatarWrapper = styled(ButtonBase)({
  borderRadius: '100%',
})

export const NavbarUserAvatar = styled(UserAvatar)({
  height: 36,
  width: 36,
  fontSize: 16,
})

